<!-- Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied. -->
<template>
  <v-layout
    wrap
    row>
    <v-flex
      xs12
      sm10
      offset-sm1
      md8
      offset-md2
      xl6
      offset-xl3
      class = "mb-4">
      <span
        class="display-3 grey--text text--darken-2"
        v-if="!short">
        DartCannon Blog
        <v-btn
          color="primary"
          icon
          flat
          ripple
          href="/static/feed.atom">
          <v-icon x-large>rss_feed</v-icon>
        </v-btn>
      </span>
    </v-flex>
    <v-list
      two-line
      v-if="short">
      <v-list-tile
        v-for="post in shown"
        :key="post.id">
        <v-list-tile-content>
          <v-list-tile-title>
            <router-link :to="post.url">{{ post.title }}</router-link>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            {{ post.subtitle }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <blog-post
      v-if="!short"
      v-for="post in shown"
      :key="post.id"
      :id = "post.id" />
  </v-layout>
</template>
<script>
import * as VList from 'vuetify/es5/components/VList'
import * as VGrid from 'vuetify/es5/components/VGrid'
import VIcon from 'vuetify/es5/components/VIcon'
import VBtn from 'vuetify/es5/components/VBtn'

import BlogPost from '@/views/BlogPost.vue'

import { posts } from '@/docs/blog.val'

export default {
  props: {
    short: {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    shown () {
      return posts.slice(0, 5)
    },
  },
  components: {
    BlogPost,
    ...VList,
    ...VGrid,
    VIcon,
    VBtn,
  },
}
</script>
